import { createProvider } from '@nvision/services/data-provider';
import { queryOptions } from '@tanstack/react-query';

import type { LocationsParams } from '../../models';
import { CACHE_KEYS } from '../../types';
import { logger } from '../../utils/logger';
import { api } from './api';
import { normalizeLocations } from './normalize';

export const fetchLocations = createProvider(api.fetchLocations)
  .andThen((res) => normalizeLocations(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      logger.warn('Fetch locations search results list aborted');
    } else {
      logger.error('Fetch locations search results list was failed:', error);
    }
    throw error;
  });

export const locationsOptions = (params: LocationsParams) =>
  queryOptions({
    enabled: Boolean(params.countryCode),
    queryFn: ({ signal }) => fetchLocations(params, { signal }),
    queryKey: CACHE_KEYS.locations(params),
  });
